import React from "react";
import Menu from "./menu";
import BlockOnMobileOverlay from "./BlockOnMobileOverlay";
import "./assets/css/patterns.css";
import "./assets/css/mobile.css";
import { useLocation } from 'react-router-dom'

export default (props: { children?: React.ReactNode }) => {
  const location = useLocation();

  return (
    <React.Fragment>
      <Menu />
      {!location.pathname.includes('/actual-update') && !location.pathname.includes('/plan-update') && !location.pathname.includes('/login') ? <BlockOnMobileOverlay /> : ''}
      {props.children}
    </React.Fragment>
  );
};
